module.exports = __webpack_public_path__ + "static/media/2DGACM11.5ee1cb02.jpg";